import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';
import { OpenCallDialogComponent } from 'src/app/components/user/open-call-dialog/open-call-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-toolbar-client',
  templateUrl: './toolbar-client.component.html',
  styleUrls: ['./toolbar-client.component.scss']
})
export class ToolbarClientComponent implements OnInit {

  constructor(
    private auth: AuthService,
    private router: Router,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
  }

  public logout() {
    this.auth.logout();
    this.router.navigate(['/login']);
  }

  public goToAddCall(): void {
    const dialogRef = this.dialog.open(OpenCallDialogComponent);

    dialogRef.afterClosed()
      .subscribe(
        () => this.router.navigate(["/cliente"]) // this.listCalls()
      );
  }
}
